export function initialsFor(name: string | null | undefined) {
  if (!name) return "HK"
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("")
}
